<template>
  <div>
    <card title="Solicitudes Despachadas desde Bodega" icon="fas fa-truck">
        <search-request-form :applicants="applicants" @exportXls="exportXls" :filter="filter" @index="index" :disable="true"></search-request-form>
        <div class="table-responsive" >
          <manage-table :hover="true" :headers="['N° de Solicitud','Nombre Solicitante','Fecha de Envío','Fecha límite de gestión','Fecha Requerida de Despacho','Fecha Despacho Bodega','Estado','Despacho Progresivo']"
                              :hasOptions="true" >
              <tr v-for="r in requests" :key="r.id">
              <td>{{ r.id }}</td>
              <td>{{ r.author.fullName }}</td>
              <td>{{ r.sendedAtString }}</td>
              <td>
                <span v-if="r.dispatchManagementDeadlineString">{{ r.dispatchManagementDeadlineString }}</span>
                <span v-else-if="r.sampleState !== 0" class="text-muted" title="Se calcula al enviar la muestra: fecha/hora de envío + 72 horas hábiles (domingo inhábil). Si el envío es a partir de las 16:30, el conteo comienza al día siguiente a las 08:00.">Pendiente de envío</span>
                <span v-else class="text-muted">Sin Registro</span>
              </td>
              <td>{{ r.requiredDispatchDateString }}</td>
              <td>{{ r.wineryDispatchDateString }}</td>
              <td>
                <span :class="r.statusColor">{{ r.status }}</span>
                <span class="badge badge-pill badge-info ml-2" v-if="r.status == 'Enviado' && r.totalPercent > 40">En Despacho</span>
              </td>
              <td v-if="r.progressDispatch == true">
                <span class="badge badge-pill badge-secondary badgeBoolean">Si</span>
              </td>
              <td v-if="r.progressDispatch == false">
                <span class="badge badge-pill badge-dark badgeBoolean">No</span>
              </td>
              <td>
                 <router-link
                  :to="'/solicitudes/visualizar/'+r.id"
                  class="btn btn-info btn-sm ml-2"
                  title="Ver Solicitud"
                >
                  <i class="fas fa-eye"></i>
                </router-link>
              </td>
            </tr>
          </manage-table>
        </div>
         <paginator class="mt-4" :links="links"></paginator>
    </card>
  </div>
</template>

<script>
import { Get} from "../../../helper/axios.js";
import Card from "../../../components/Card.vue";
import {getUrlQuery} from "../../../helper/queryHelper";
import * as XLSX from "xlsx";
export default {
  components: {
    Card
  },
  data() {
    return {
      ListWineryDispatch: [],
      apiUrl: this.$store.getters.apiUrl,
      Get,
      cCenter: {},
      links: {},
      getUrlQuery,
      requests: [],
      filter: {
        number: "",
        to: "",
        from: "",
        state: "",
      },
      applicants: []
    };
  },
  watch:{
    urlQuery:function(){
      this.index()
    }
  },
  created() {
    this.index();
    this.getApplicants();
  },
  methods: {
    index() { 
      this.$store.commit("setLoading", true);
      this.Get(this.apiUrl + "v1/winerydispatched?" + this.urlQuery, (res) => { 
        this.requests = res.data.data; 
        this.links = res.data.links;
        this.$store.commit("setLoading", false);
      }); 
    },
    getApplicants(){
      this.$store.commit("setLoading", true);
      this.Get(this.apiUrl + "v1/applicants", (res) => {
        res.data.forEach(item => {
            this.applicants.push({
                code: item.id,
                label: item.fullName
            });
        });
        this.$store.commit("setLoading", false);
      });
    },
    reset() {
      this.links = {}
      this.index()
    },
    exportXls() {
      this.$store.commit("setLoading", true);
      this.Get(this.apiUrl + "v1/exportrequestsamples?" + this.urlQuery + "&state=Desde_Despacho_Bodega", (res) => {
        let requestDataList = [];
        let requestData = {};
        let filename = "Solicitudes Fcom - Despachadas"; //max 31 character
        res.data.forEach((element) => {
          requestData = {
              "Fcom N°" : element.id,
              "Nombre Solicitante": element.authorData.fullName,
              "Correo Solicitante": element.authorData.email,
              "Fecha Solicitud": element.createdAtString,
              "Despacho Progresivo": element.progressDispatch == false ? "No" : "Si",
              "Fecha Requerida Despacho": element.requiredDispatchDateString,
              "Fecha Despacho Bodega": element.wineryDispatchDateString,
              "Estado": element.status,              
          }
          requestDataList.push(requestData);
        });

        let data = XLSX.utils.json_to_sheet(requestDataList);
        data["!cols"] = [{ wpx : 70 },{ wpx : 180 },{ wpx : 210 },{ wpx : 120 },{ wpx : 140 },{ wpx : 180 },{ wpx : 160 },{ wpx : 120 }];
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, data, filename);
        XLSX.writeFile(workbook, `${filename}.xlsx`);    
        this.$store.commit("setLoading", false);
      });
    }
  
  },
  computed:{
    urlQuery(){
        return this.getUrlQuery()
    }
  }

}

</script>